import { Component } from '@angular/core';
import {  OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';

import { Subscription } from 'rxjs/Rx';

import { TranslateService } from '@ngx-translate/core';

import { RootService } from '../../../service/root.service';

import { User } from '../shared/user';
import { UserService } from '../shared/user.service';

import { ConfirmationService } from 'primeng/primeng';


@Component({
    selector: 'user-list',
    templateUrl: './user-list.component.html',
    styleUrls: ['./user-list.component.scss']
})
export class UserListComponent implements OnInit, OnDestroy {

    @Input() selectedUser;
    @Output() selectedUserChange = new EventEmitter();
    @Input() operation: string;
    fromRoute: boolean;

    users: User[];


    routeEvent: Subscription;
    requestXHR: Subscription;
    requestError: boolean;
    noResult: boolean;

    constructor(public rootService: RootService,
        public translate: TranslateService) {
    }

    ngOnInit() {
    }

    ngOnDestroy() {
    }
}



// WEBPACK FOOTER //
// ./src/app/module/user/user-list/user-list.component.ts